import React, { useState, ReactNode } from 'react';
import { Button } from 'antd';
import { CodeXml } from 'lucide-react';
import WordpressIcon from '../../../../../assets/images/icon-wordpress.svg';
import cx from 'classnames';
import ExtensionInstallButton from '../../../components/onboarding/install_button';
import { detect } from 'detect-browser';
import browserResources from '../../../components/onboarding/extension_config.json';
import styles from './styles.module.css';
import * as translations from '../strings';
import { getLangKey } from 'appJS/models/Language';
import { InstallOptionKeys } from './index';

const strings = translations[getLangKey()];

const browser = detect();
const currentBrowser = browser?.name;
const browserConfig = browserResources.find(
  browser => browser.name === currentBrowser
);

const icons = [
  <CodeXml className={styles.icon} />,
  undefined,
  <WordpressIcon className={styles.wordPressIcon} />
];

export const InstallOptionCard = ({
  content,
  title,
  description,
  onClick,
  active,
  index,
  itemKey
}: {
  content?: ReactNode;
  title: string;
  description: string | ReactNode[];
  onClick: (callback?: () => void) => void;
  active: boolean;
  index: number;
  itemKey: InstallOptionKeys;
}) => {
  const [extensionClicked, setExtensionClicked] = useState<boolean>(false);
  let callback: () => void | undefined;
  if (itemKey === InstallOptionKeys.Extension)
    callback = () => setExtensionClicked(true);

  return (
    <div
      className={cx(styles.installOptionCard, { [styles.active]: active })}
      onClick={() => onClick(callback)}
    >
      <div className={styles.optionLabel}>{`Option ${index + 1}${
        itemKey === InstallOptionKeys.Javascript ? strings.recommended : ''
      }`}</div>
      <div className={styles.optionContent}>
        <div className={styles.headerContainer}>
          <h3 className={styles.installOptionTitle}>{title}</h3>
          {itemKey === InstallOptionKeys.Wordpress && active && (
            <WordpressIcon className={styles.headerIcon} />
          )}
        </div>
        <p className={styles.installOptionDescription}>{description}</p>
        {(active && content) || null}
      </div>
      {!active &&
        (itemKey === InstallOptionKeys.Extension ? (
          <ExtensionInstallButton
            browserConfig={browserConfig}
            alternateCta="Get extension"
            className={styles.extensionButton}
            extensionClicked={extensionClicked}
            setExtensionClicked={setExtensionClicked}
          />
        ) : (
          <Button
            type="primary"
            className={styles.actionButton}
            icon={
              icons[index] && (
                <span className={styles.iconOuter}>{icons[index]}</span>
              )
            }
          >
            {strings[`${itemKey}ButtonLabel`]}
          </Button>
        ))}
    </div>
  );
};
